import React from 'react';
import { Link } from 'react-router-dom';
import logoIcon from '@/assets/images/pngs/OMIKUJI-Main-Logo.png';

const LandingPage: React.FC = () => {
    return (
        <div className='min-h-screen bg-gradient-to-b from-green-50 to-white font-sans'>
            {/* Navbar */}
            <nav className='flex items-center justify-between p-4 bg-white shadow-md'>
                <div className='flex items-center space-x-2'>
                    <img src={logoIcon} alt='OMIKUJI Logo' className='h-8 w-auto' />
                </div>
                <Link
                    to='/login'
                    className='px-4 py-2 text-white bg-green-500 rounded-full hover:bg-green-600 text-base transition'
                >
                    ログインする
                </Link>
            </nav>

            {/* Hero Section */}
            <section className='flex flex-col items-center justify-center h-[70vh] text-center px-4'>
                <h2 className='text-4xl md:text-5xl font-extrabold text-gray-900 mb-4'>
                    アイテムとクーポンを集めよう！
                </h2>
                <p className='text-lg md:text-xl text-gray-600 mb-6 max-w-2xl'>
                    OMIKUJIへようこそ！ユニークなアイテムを集めて、素敵なクーポンを手に入れましょう。あなたの運勢を占ってみましょう！
                </p>
                <Link
                    to='/login'
                    className='px-6 py-3 text-lg font-semibold text-white bg-green-500 rounded-full hover:bg-green-600 transition'
                >
                    今すぐ集め始める
                </Link>
            </section>

            {/* Features Section */}
            <section className='py-16 bg-gray-50'>
                <div className='max-w-6xl mx-auto px-4'>
                    <h3 className='text-3xl font-bold text-center text-gray-900 mb-12'>
                        OMIKUJIを選ぶ理由
                    </h3>
                    <div className='grid grid-cols-1 md:grid-cols-3 gap-8'>
                        <div className='flex flex-col items-center text-center p-6 bg-white rounded-lg shadow-md'>
                            <svg className='w-12 h-12 text-green-500 mb-4' viewBox='0 0 24 24' fill='currentColor'>
                                <path d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 15.5v-1.5c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1v-1.5c0-.83-.67-1.5-1.5-1.5h-1c-.83 0-1.5.67-1.5 1.5V12H5v-1.5C5 8.57 6.57 7 8.5 7h1C11.43 7 13 8.57 13 10.5v1.5c0 .55-.45 1-1 1H9v2h3c.55 0 1 .45 1 1v1.5c0 .83.67 1.5 1.5 1.5h1c.83 0 1.5-.67 1.5-1.5V16h2v1.5c0 1.93-1.57 3.5-3.5 3.5h-1c-1.93 0-3.5-1.57-3.5-3.5z' />
                            </svg>
                            <h4 className='text-xl font-semibold text-gray-800 mb-2'>ユニークなアイテムを集める</h4>
                            <p className='text-gray-600'>
                                毎日アイテムを引いて、あなたのコレクションを増やしましょう。
                            </p>
                        </div>
                        <div className='flex flex-col items-center text-center p-6 bg-white rounded-lg shadow-md'>
                            <svg className='w-12 h-12 text-green-500 mb-4' viewBox='0 0 24 24' fill='currentColor'>
                                <path d='M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-2 10h-4v2h4v2H6v-2h4v-2H6v-2h4v-2H6V8h4V6H6V6h12v8z' />
                            </svg>
                            <h4 className='text-xl font-semibold text-gray-800 mb-2'>クーポンを交換する</h4>
                            <p className='text-gray-600'>
                                集めたアイテムを使って、素敵なクーポンや割引を手に入れましょう。
                            </p>
                        </div>
                        <div className='flex flex-col items-center text-center p-6 bg-white rounded-lg shadow-md'>
                            <svg className='w-12 h-12 text-green-500 mb-4' viewBox='0 0 24 24' fill='currentColor'>
                                <path d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 15l-5-5 1.41-1.41L11 14.17l7.59-7.59L20 8l-9 9z' />
                            </svg>
                            <h4 className='text-xl font-semibold text-gray-800 mb-2'>毎日の報酬</h4>
                            <p className='text-gray-600'>
                                毎日ログインして新しい報酬を獲得し、勝利のチャンスを増やしましょう。
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Google API Services & Security Section */}
            <section className='py-16 bg-white'>
                <div className='max-w-6xl mx-auto px-4'>
                    <h3 className='text-3xl font-bold text-center text-gray-900 mb-12'>
                        Google API サービスとセキュリティ
                    </h3>
                    <div className='flex flex-col items-center text-center p-8 bg-gray-50 rounded-lg shadow-md max-w-3xl mx-auto'>
                        <svg className='w-12 h-12 text-blue-600 mb-4' viewBox='0 0 24 24' fill='currentColor'>
                            <path d='M7.77 6.76L6.23 5.48.82 12l5.41 6.52 1.54-1.28L3.42 12zM7 13h2v-2H7zm10-2h-2v2h2zm-6 2h2v-2h-2zm6.77-7.52l-1.54 1.28L20.58 12l-4.35 5.24 1.54 1.28L23.18 12z' />
                        </svg>
                        <h4 className='text-2xl font-semibold text-gray-800 mb-4'>
                            Google Auth を使用した安全なログイン
                        </h4>
                        <p className='text-gray-600 mb-4'>
                            OMIKUJIでは、Google Authを使用してユーザーのログインを安全に管理しています。Googleアカウントを通じて、メールアドレスと基本的なプロフィール情報のみを取得し、認証目的でのみ使用します。
                        </p>
                        <p className='text-gray-600'>
                            私たちは、不要なデータ収集を行わず、取得した情報はすべて安全に保管されます。Googleのポリシーに準拠し、ユーザーデータの保護を最優先に考えています。詳細については、
                            <a href={window.location.origin + '/policy.html'} className='text-blue-600 underline'>プライバシーポリシー</a>
                            をご覧ください。
                        </p>
                    </div>
                </div>
            </section>

            {/* Footer */}
            <footer className='py-6 bg-gray-100 text-center'>
                <p className='text-gray-600'>
                    © 2025 OMIKUJI. すべての権利を保有します。
                </p>
                <a href={window.location.origin + '/policy.html'} className='text-blue-600 underline mt-2 block'>
                    プライバシーポリシー
                </a>
            </footer>
        </div>
    );
};

export default LandingPage;
